import { render, staticRenderFns } from "./CreatePlace.vue?vue&type=template&id=72ce8902&lang=html&"
import script from "./CreatePlace.vue?vue&type=script&lang=js&"
export * from "./CreatePlace.vue?vue&type=script&lang=js&"
import style0 from "./CreatePlace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports